/**
 * Dates and numbers in Beam's voice (DESIGN.md, Voice): "2 Sep" in dense
 * rows, "2 September 2026" in prose, digits everywhere. Australian English
 * locale so month names and order are right without a library.
 */

// Fixed three-letter months: en-AU's Intl short form gives "Sept", DESIGN.md says "2 Sep".
const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const LONG = new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
const TIME = new Intl.DateTimeFormat('en-AU', { hour: 'numeric', minute: '2-digit', hour12: true });

export function shortDate(iso: string): string {
  const d = new Date(iso);
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

export function longDate(iso: string): string {
  return LONG.format(new Date(iso));
}

export function dateTime(iso: string): string {
  return `${shortDate(iso)}, ${TIME.format(new Date(iso))}`;
}

/** "4:15 pm" on its own, for a line that already carries the date. */
export function timeOfDay(iso: string): string {
  return TIME.format(new Date(iso));
}

/** Today's calendar date where the user is (YYYY-MM-DD); toISOString would give the UTC date, yesterday in Perth before 08:00. */
export function localDateKey(d: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function isPast(isoDate: string, now: Date = new Date()): boolean {
  return new Date(isoDate).getTime() < now.getTime();
}

export function initials(name: string): string {
  return name.split(/\s+/).filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase() ?? '').join('');
}

export function pluralise(n: number, one: string, many: string = `${one}s`): string {
  return `${n} ${n === 1 ? one : many}`;
}
